import { TextKey } from '@mews-commander/enums';

export const TEXT_LENGTH = 35;

export const customerTypesOptions = {
    customer: TextKey.Customer,
    company: TextKey.Company,
    ota: TextKey.TravelAgency,
};
